import { render, staticRenderFns } from "./SocialStatuseFilter.vue?vue&type=template&id=1228868e&"
import script from "./SocialStatuseFilter.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports